(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = window.matchMedia('(max-width: 899px)');
  var lightbox = document.querySelector('[data-pf-lightbox]');
  var lightboxSlot = lightbox ? lightbox.querySelector('[data-pf-lightbox-slot]') : null;
  var lightboxPlaceholder = null;
  var lightboxActive = null;

  function pauseOthers(except) {
    document.querySelectorAll('[data-pf-media]').forEach(function (wrap) {
      if (wrap === except) return;
      var video = wrap.querySelector('video');
      var playBtn = wrap.querySelector('[data-pf-play]');
      var soundBtn = wrap.querySelector('[data-pf-sound]');
      if (!video) return;
      video.pause();
      wrap.classList.remove('is-playing');
      if (playBtn) playBtn.hidden = false;
      if (soundBtn) soundBtn.hidden = true;
    });
  }

  function syncSoundLabel(wrap, video) {
    var soundBtn = wrap.querySelector('[data-pf-sound]');
    if (!soundBtn) return;
    var onLabel = soundBtn.getAttribute('data-label-on') || 'Click for sound';
    var offLabel = soundBtn.getAttribute('data-label-off') || 'Click for mute';
    soundBtn.textContent = video.muted ? onLabel : offLabel;
  }

  function setThumbFrame(video, wrap) {
    if (wrap.getAttribute('data-thumb-ready') === '1') return;

    function seek() {
      if (!video.duration || !isFinite(video.duration) || video.duration <= 0) return;
      wrap.setAttribute('data-thumb-ready', '1');
      try {
        video.currentTime = Math.max(0.05, video.duration * 0.1);
      } catch (err) {
        /* ignore seek errors */
      }
    }

    if (video.readyState >= 1) seek();
    else video.addEventListener('loadedmetadata', seek, { once: true });
  }

  function openReelLightbox(wrap) {
    if (!mobileMq.matches || !lightbox || !lightboxSlot) return;
    if (lightboxActive === wrap) return;
    if (lightboxActive) closeReelLightbox(false);
    lightboxPlaceholder = document.createComment('pf-reel-slot');
    wrap.parentNode.insertBefore(lightboxPlaceholder, wrap);
    lightboxSlot.appendChild(wrap);
    lightbox.hidden = false;
    document.body.classList.add('pf-lightbox-open');
    lightboxActive = wrap;
  }

  function closeReelLightbox(pause) {
    if (!lightboxActive || !lightboxPlaceholder || !lightboxPlaceholder.parentNode) {
      if (lightbox) lightbox.hidden = true;
      document.body.classList.remove('pf-lightbox-open');
      lightboxActive = null;
      lightboxPlaceholder = null;
      return;
    }
    if (pause !== false) pauseMedia(lightboxActive);
    lightboxPlaceholder.parentNode.insertBefore(lightboxActive, lightboxPlaceholder);
    lightboxPlaceholder.remove();
    lightbox.hidden = true;
    document.body.classList.remove('pf-lightbox-open');
    lightboxActive = null;
    lightboxPlaceholder = null;
  }

  function playMedia(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var playBtn = wrap.querySelector('[data-pf-play]');
    var soundBtn = wrap.querySelector('[data-pf-sound]');
    var hasAudio = wrap.getAttribute('data-audio') === 'true';

    pauseOthers(wrap);
    if (wrap.getAttribute('data-pf-reel') === 'true') {
      openReelLightbox(wrap);
    }
    if (wrap.getAttribute('data-started') !== '1') {
      try {
        video.currentTime = 0;
      } catch (err) {
        /* ignore */
      }
      wrap.setAttribute('data-started', '1');
    }
    if (hasAudio) {
      video.muted = false;
    } else {
      video.muted = true;
    }
    var play = video.play();
    if (play && play.catch) {
      play.catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }
    wrap.classList.add('is-playing');
    if (playBtn) playBtn.hidden = true;
    if (soundBtn && hasAudio) {
      soundBtn.hidden = false;
      syncSoundLabel(wrap, video);
    }
  }

  function pauseMedia(wrap) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-pf-play]');
    var soundBtn = wrap.querySelector('[data-pf-sound]');
    if (!video) return;
    video.pause();
    wrap.classList.remove('is-playing');
    if (playBtn) playBtn.hidden = false;
    if (soundBtn) soundBtn.hidden = true;
  }

  function initMedia(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var playBtn = wrap.querySelector('[data-pf-play]');
    var soundBtn = wrap.querySelector('[data-pf-sound]');
    var hasAudio = wrap.getAttribute('data-audio') === 'true';

    video.playsInline = true;
    video.loop = true;
    video.controls = false;
    video.removeAttribute('autoplay');
    setThumbFrame(video, wrap);

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) playMedia(wrap);
        else pauseMedia(wrap);
      });
    }

    video.addEventListener('click', function () {
      if (video.paused) playMedia(wrap);
      else pauseMedia(wrap);
    });

    if (soundBtn && hasAudio) {
      soundBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        syncSoundLabel(wrap, video);
      });
    }
  }

  function initLightbox() {
    if (!lightbox) return;
    var closeBtn = lightbox.querySelector('[data-pf-lightbox-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeReelLightbox(true);
      });
    }
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeReelLightbox(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightboxActive) closeReelLightbox(true);
    });
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', function (e) {
        if (!e.matches && lightboxActive) closeReelLightbox(true);
      });
    }
  }

  function setExpandText(btn, open) {
    var more = btn.getAttribute('data-label-more') || 'Click here for more';
    var less = btn.getAttribute('data-label-less') || 'Click for less';
    var text = open ? less : more;
    var label =
      btn.querySelector('[data-pf-expand-label]') ||
      btn.querySelector('[data-pf-yt-expand-label]');
    if (label) label.textContent = text;
    btn.querySelectorAll('[data-pf-marquee-item]').forEach(function (item) {
      item.textContent = text;
    });
  }

  function initMotionMarquee(btn) {
    var track = btn.querySelector('[data-pf-marquee-track]');
    if (!track) return function () {};

    var half = 0;
    var cloned = false;

    function measure() {
      if (!reduced && !cloned) {
        Array.prototype.slice.call(track.children).forEach(function (node) {
          track.appendChild(node.cloneNode(true));
        });
        cloned = true;
      }
      half = track.scrollWidth / 2;
    }

    function update() {
      if (reduced || !half) return;
      var shift = (window.scrollY * 0.45) % half;
      track.style.transform = 'translate3d(' + -shift + 'px, 0, 0)';
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      update();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measure();
        update();
      });
    }

    return function () {
      measure();
      update();
    };
  }

  function initExpand() {
    document.querySelectorAll('[data-pf-expand]').forEach(function (btn) {
      var targetId = btn.getAttribute('aria-controls');
      var panel = targetId ? document.getElementById(targetId) : null;
      if (!panel) return;
      var refreshMarquee = btn.hasAttribute('data-pf-marquee') ? initMotionMarquee(btn) : function () {};
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var nextOpen = !open;
        btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        panel.hidden = !nextOpen;
        btn.classList.toggle('is-open', nextOpen);
        setExpandText(btn, nextOpen);
        refreshMarquee();
      });
    });
  }

  function initYtExpand() {
    var btn = document.querySelector('[data-pf-yt-expand]');
    var grid = document.querySelector('[data-pf-yt]');
    if (!btn || !grid) return;
    var refreshMarquee = btn.hasAttribute('data-pf-marquee') ? initMotionMarquee(btn) : function () {};
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var nextOpen = !open;
      btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      grid.classList.toggle('is-expanded', nextOpen);
      btn.classList.toggle('is-open', nextOpen);
      setExpandText(btn, nextOpen);
      refreshMarquee();
    });
  }

  function initBackTop() {
    var btn = document.querySelector('[data-pf-top]');
    if (!btn) return;
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-pf-tone]'));

    function updateVisibility() {
      var show = window.scrollY > 120;
      btn.hidden = !show;
      btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function updateTone() {
      var mid = window.innerHeight * 0.82;
      var active = 'light';
      sections.forEach(function (section) {
        var rect = section.getBoundingClientRect();
        if (rect.top <= mid && rect.bottom >= mid) {
          active = section.getAttribute('data-pf-tone') || 'light';
        }
      });
      btn.setAttribute('data-tone', active);
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    window.addEventListener(
      'scroll',
      function () {
        updateVisibility();
        updateTone();
      },
      { passive: true }
    );
    updateVisibility();
    updateTone();
  }

  function initUxAutoplay() {
    document.querySelectorAll('[data-pf-ux-video]').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      if (reduced) return;
      function play() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (video.readyState >= 2) play();
      else video.addEventListener('canplay', play);
    });
  }

  function initNav() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initCommercialCarousels() {
    document.querySelectorAll('[data-pf-commercial]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.pf-commercial__img'));
      if (slides.length < 2) return;
      var frame = root.querySelector('.pf-commercial__frame');
      var index = slides.findIndex(function (img) {
        return img.classList.contains('is-active');
      });
      if (index < 0) index = 0;

      function show(next) {
        var i = ((next % slides.length) + slides.length) % slides.length;
        slides.forEach(function (img, n) {
          var on = n === i;
          img.classList.toggle('is-active', on);
          if (on) img.removeAttribute('hidden');
          else img.setAttribute('hidden', '');
        });
        index = i;
      }

      function stepFromEvent(e) {
        if (!frame) return;
        var rect = frame.getBoundingClientRect();
        if (e.clientX < rect.left + rect.width / 2) show(index - 1);
        else show(index + 1);
      }

      var prev = root.querySelector('[data-pf-commercial-prev]');
      var next = root.querySelector('[data-pf-commercial-next]');
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.stopPropagation();
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.stopPropagation();
          show(index + 1);
        });
      }
      if (frame) {
        frame.addEventListener('click', function (e) {
          if (e.target.closest('.pf-commercial__nav')) return;
          stepFromEvent(e);
        });
        frame.addEventListener('mousemove', function (e) {
          var rect = frame.getBoundingClientRect();
          var left = e.clientX < rect.left + rect.width / 2;
          frame.classList.toggle('pf-commercial__frame--prev', left);
          frame.classList.toggle('pf-commercial__frame--next', !left);
        });
        frame.addEventListener('mouseleave', function () {
          frame.classList.remove('pf-commercial__frame--prev', 'pf-commercial__frame--next');
        });
      }
    });
  }

  document.querySelectorAll('[data-pf-media]').forEach(initMedia);
  initLightbox();
  initExpand();
  initYtExpand();
  initBackTop();
  initUxAutoplay();
  initCommercialCarousels();
  initNav();
})();
